import React, { useEffect, useRef, useState } from "react";
import PleaseLoginPrompt from "./PleaseLoginPrompt";
import { endpoints } from "../utils/Constants";
import HeartFilled from "../assets/icons/heart-filled.svg";
import HeartOutline from "../assets/icons/heart-outline.svg";

const FavouriteButton = () => {
  const loginRef = useRef();
  const [following, setFollowing] = useState(false);

  const nodeId = $('#EventGroupNodeId').text();
  const isAuthenticated = $("#__HD_RequestVerificationToken").length > 0;

  useEffect(() => {
      if (isAuthenticated) fetchData();
  }, []);

  const fetchData = () => {
    let url = endpoints.event.followEventGroup(nodeId);

    fetch(url, {
      method: "GET",
    })
      .then((res) => res.json())
      .then(setFollowing)
      .catch(() => {});
  };

  const follow = (unfollow) => {
    let url = endpoints.event.followEventGroup(nodeId);

    fetch(url, {
      method: unfollow ? "DELETE" : "POST",
    })
      .then(() => {
          if (!unfollow) {
              GoogleAnalytics.trackEvent(GoogleAnalytics.events.AddToFavorites, {
                  node_id: nodeId
              });
          }
        setFollowing(!unfollow);
      })
      .catch(() => {});
  };

  const handleClick = () => {
      if (!isAuthenticated) loginRef.current?.handleOpen();
    else if (following) follow(true);
    else follow();
  };

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 80,
          backgroundColor: "#FFFFFF",
          cursor: "pointer",
        }}
      >
        {following ? <HeartFilled /> : <HeartOutline />}
      </div>

      <PleaseLoginPrompt
        prompt={tickets_resources.SignInToFavourite}
        icon={"/site/images/icons/heart-favourite.png"}
        ref={loginRef}
      />
    </>
  );
};

export default FavouriteButton;
